/**
 *
 * ThemeProvider
 *
 * this component connects the redux state theme object to the
 * styled-component ThemeProvider component
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

import { selectCurrentTheme } from './selectors';

/* eslint-disable react/prefer-stateless-function */
export class ThemeProvider extends React.PureComponent {
    render() {
        const { theme, children } = this.props;
        return (
            <StyledComponentsThemeProvider theme={theme}>{React.Children.only(children)}</StyledComponentsThemeProvider>
        );
    }
}

ThemeProvider.propTypes = {
    theme: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

const mapStateToProps = (state) => ({
    theme: selectCurrentTheme(state),
});

export default connect(mapStateToProps)(ThemeProvider);
